export const HOME = '/'
export const UPLOAD = '/upload'
export const PROFILE = '/profile'
export const DISCLAIMER = '/disclaimer'
export const DEVELOPMENT_IN_PROGRESS = '/development-in-progress'
export const SIGN_UP = '/sign-up'
export const SIGN_IN = '/sign-in'
export const FORGOT_PASSWORD = '/forgot-password'
export const NOT_VERIFIED = "/not-verified"
export const APPLE_APP_STORE = "https://apps.apple.com/hu/app/printprincess/id1591406980"